import { notNil } from 'app/utils/stream-util';
import User from 'entity/User';

/**
 *
 * @param total The total count of items
 * @param pageSize The size of the page
 * @returns The number of pages that can be displayed for a specific amount of items.
 */
export const getPageCount = (total: number, pageSize: number): number => {
  return total % pageSize === 0 ? total / pageSize : ~~(total / pageSize) + 1;
};

export const getUsersRemovedFromAudience = (prev: User[], current: User[]): string[] => {
  const prevIds = prev.map((u) => u.userId).filter(notNil);
  const currentIds = current.map((u) => u.userId).filter(notNil);
  return prevIds.filter((p) => !currentIds.includes(p));
};

export const getUsersAddedToAudience = (prev: User[], current: User[]): string[] => {
  const prevIds = prev.map((u) => u.userId).filter(notNil);
  const currentIds = current.map((u) => u.userId).filter(notNil);
  return currentIds.filter((p) => !prevIds.includes(p));
};

export const isSameAudience = (previous: User[], current: User[]): boolean => {
  return previous.every((p) => !!current.find((c) => c.userId === p.userId)) && previous.length === current.length;
};
